import axios from 'axios';
import {
    Message
} from 'element-ui';

axios.defaults.timeout = 30000;
axios.defaults.baseURL = window.g.API_ROOT; //填写域名
// axios.defaults.baseURL = 'https://sso.kayicloud.com'; //填写域名

//headers加参数
axios.interceptors.request.use(config => {
    config.headers.common["Authorization"] = localStorage.getItem(
        "mobile_internet_writing_accessToken"
    );
    return config;
});

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 401:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 403:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 404:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 405:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 408:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 500:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 501:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 502:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 503:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 504:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            case 505:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
                break;
            default:
                Message({
                    type: "error",
                    message: err.response.data.error
                });
        }
    } else {
        Message({
            type: "error",
            message: err.response.data.error
        });
    }
    return Promise.resolve(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装get请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param params
 * @returns {Promise}
 */

export function patch(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, {
                params: params
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/*下面是获取数据的接口*/
export const server = {
    //AI调阅
    getpicurl: function(paramObj) {
        return fetch('/api/v1/hospitalyuanneirecord/getpicurl', paramObj);
    },
    //获取医院列表
    getHospitalGetList: function(paramObj) {
        return get('/api/v1/hospital/getlist', paramObj);
    },
    //注册接口
    postUserRegisterUser: function(paramObj) {
        return post('/api/v1/user/registeruser', paramObj);
    },
    //获取检查部门列表
    getCheckRoomGetDepList: function(paramObj) {
        return fetch('/api/v1/checkroom/getdeplist', paramObj);
    },
    //获取检查设备类别
    getCheckRoomGetModalityList: function(paramObj) {
        return fetch('/api/v1/checkroom/getmodalitylist', paramObj);
    },
    //获取检查部位
    getchildpartlist: function(paramObj) {
        return fetch('/api/v1/registerpart/getchildpartlist', paramObj);
    },
    //获取检查报告分页列表
    getPatReportPages: function(paramObj) {
        return fetch('/api/v1/hospitalyuanneirecord/getpatreportpages', paramObj);
    },
    //获取检查报告分页高级列表
    getPatReportPagesByadvanced: function(paramObj) {
        return post('/api/v1/hospitalyuanneirecord/getpatreportpagesbyadvanced', paramObj);
    },
    //获取获取患者报告
    getPatMode: function(paramObj) {
        return fetch('/api/v1/hospitalyuanneirecord/getmodel', paramObj);
    },
    //获取分享链接
    getQRcodeUrlByShare(paramObj) {
        return fetch('/api/v1/hospitalyuanneirecord/getqrcodeurlbyshare', paramObj);
    },
    //获取图像调阅链接
    getPicUrl(paramObj) {
        return fetch('/api/v1/hospitalyuanneirecord/getpicurl', paramObj);
    },
    //获取检查报告历史列表
    getPatHistoryList(paramObj) {
        return fetch('/api/v1/hospitalyuanneirecord/getlist', paramObj);
    },
    //获影像分页列表
    getStudyPages(paramObj) {
        return fetch('/api/v1/ReportApi/getstudypages', paramObj);
    },
    //获取公共词库树形
    getReportTemplateTree(paramObj) {
        return fetch('/api/v1/reporttemplate/gettree', paramObj);
    },
    //获取公有词库模板对象
    getReportTemplateTreeModel(paramObj) {
        return fetch('/api/v1/reporttemplate/getmodel', paramObj);
    },
    //获取私有词库树形
    getReportTemplatePrivateTree(paramObj) {
        return fetch('/api/v1/reporttemplateprivate/gettree', paramObj);
    },
    //获取私有词库模板对象
    getReportTemplatePrivateTreeModel(paramObj) {
        return fetch('/api/v1/reporttemplateprivate/getmodel', paramObj);
    },
    //获取报告类型 只查询XRAY、CT、MRI部门
    getReportDiseaseList(paramObj) {
        return fetch('/api/v1/reportdiseasedmb/getreportdiseaselist', paramObj);
    },
    //临时保存
    postTempSave: function(paramObj) {
        return post('/api/v1/templatereportsave/tempsave', paramObj);
    },
    //获取临时保存
    getTemplateReportSaveModel(paramObj) {
        return fetch('/api/v1/templatereportsave/getmodel', paramObj);
    },
    //获取危急值
    getDangerList(paramObj) {
        return fetch('/api/v1/itemdicdmb/getdangerlist', paramObj);
    },
    //报告保存
    postSaveReport: function(paramObj) {
        return post('/api/v1/hospitalyuanneirecord/savereport', paramObj);
    },
    //报告审核
    postAuditReport: function(paramObj) {
        return post('/api/v1/hospitalyuanneirecord/auditreport', paramObj);
    },
}


// WEBPACK FOOTER //
// ./src/api/http-service.js